import { DownOutlined } from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  FormInstance,
  Input,
  Menu,
  Row
} from "antd";

import TextArea from "antd/lib/input/TextArea";
import * as React from "react";
import { IStore } from "../../model/runtime/state/Store";
import SelectInput from "./SelectInput";
export interface State {
  realValue?: string;
}

export interface Props {
  rowData?: any;
  translate;
  organisationId?: number;
  translationObjectIdFieldName: string;
  store: IStore;
  form: FormInstance;
  label: string;
  noteLabel?: string;
}
const FormFields = {
  ID: "id",
  ORGANISATION_ID: "organisationId",
  LANGUAGE_ID: "languageId",
  SUMMARY_TRANSLATION: "summaryTranslation",
  NOTE_TRANSLATION: "noteTranslation",
  VALID: "valid"
};

function getSelection() {
  if (window.getSelection) {
    // all browsers, except IE before version 9
    var selectionRange = window.getSelection();
    return selectionRange?.toString();
  } else {
    if ((document as any).selection.type === "None") {
      return "";
    } else {
      var textRange = (document as any).selection.createRange();
      return textRange.text;
    }
  }
}

function getInputSelection(el) {
  var start = 0,
    end = 0,
    normalizedValue,
    range,
    textInputRange,
    len,
    endRange;

  if (
    typeof el.selectionStart == "number" &&
    typeof el.selectionEnd == "number"
  ) {
    start = el.selectionStart;
    end = el.selectionEnd;
  } else {
    range = getSelection().createRange();

    if (range && range.parentElement() === el) {
      len = el.value.length;
      normalizedValue = el.value.replace(/\r\n/g, "\n");

      // Create a working TextRange that lives only in the input
      textInputRange = el.createTextRange();
      textInputRange.moveToBookmark(range.getBookmark());

      // Check if the start and end of the selection are at the very end
      // of the input, since moveStart/moveEnd doesn't return what we want
      // in those cases
      endRange = el.createTextRange();
      endRange.collapse(false);

      if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
        start = end = len;
      } else {
        start = -textInputRange.moveStart("character", -len);
        start += normalizedValue.slice(0, start).split("\n").length - 1;

        if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
          end = len;
        } else {
          end = -textInputRange.moveEnd("character", -len);
          end += normalizedValue.slice(0, end).split("\n").length - 1;
        }
      }
    }
  }

  return {
    start: start,
    end: end
  };
}

function replaceSelectedText(el, text) {
  var sel = getInputSelection(el),
    val = el.value;
  el.value = val.slice(0, sel.start) + text + val.slice(sel.end);
}

export default class TranslationTextAreaField extends React.Component<
  Props,
  State
> {
  constructor(props: Props) {
    super(props);
    this.state = {
      realValue: undefined
    };
  }

  render() {
    const {
      organisationId,
      translate,
      translationObjectIdFieldName,
      store,
      form,
      label,
      noteLabel
    } = this.props;

    const { languages } = store.getState<any>();
    const getSummaryLabel = (index: number) => {
      let languageName =
        languages.find(
          (item) =>
            item.id ===
            form.getFieldsValue()?.summaryTranslations?.[index]?.languageId
        )?.name || undefined;
      return languageName ? `${label} (${languageName})` : label;
    };
    const getNoteLabel = (index: number) => {
      let languageName =
        languages.find(
          (item) =>
            item.id ===
            form.getFieldsValue()?.summaryTranslations?.[index]?.languageId
        )?.name || undefined;
      return languageName ? `${noteLabel} (${languageName})` : noteLabel;
    };

    return (
      <Form.List name="summaryTranslations">
        {(fields, { add, remove }) => {
          return (
            <>
              {fields.map((field, index) => (
                <Row key={field.key} gutter={16}>
                  <Col sm={24} xs={24}>
                    <Form.Item
                      name={[index, FormFields.ID]}
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>
                    <Form.Item
                      name={[index, FormFields.ORGANISATION_ID]}
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>

                    <Form.Item
                      name={[index, translationObjectIdFieldName]}
                      style={{ display: "none" }}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col lg={5} md={5} sm={5} xs={24} style={{ display: "none" }}>
                    <Form.Item
                      name={[index, FormFields.LANGUAGE_ID]}
                      label={"Jezik"}
                    >
                      <SelectInput
                        disabled
                        selectOptionKey={"id"}
                        selectOptionValue={"name"}
                        selectOptions={store.getState<any>().languages}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={24}>
                    {index === 0 ? (
                      <Row>
                        <Col span={4} offset={21}>
                          <Form.Item className={"mb-0"}>
                            <Dropdown
                              overlay={
                                <Menu
                                  onClick={(info) =>
                                    add({
                                      languageId: Number.parseInt(info.key, 10),
                                      organisationId: organisationId,
                                      valid: true
                                    })
                                  }
                                >
                                  {languages
                                    .filter(
                                      (language) =>
                                        form
                                          .getFieldsValue()
                                          .summaryTranslations?.map(
                                            (item) => item.languageId
                                          )
                                          .indexOf(language.id) === -1
                                    )
                                    ?.map((item) => (
                                      <Menu.Item key={item.id}>
                                        {item.name}
                                      </Menu.Item>
                                    ))}
                                </Menu>
                              }
                            >
                              <Button>
                                {translate(
                                  "editors.case_law_documents.add_translation"
                                )}{" "}
                                <DownOutlined />
                              </Button>
                            </Dropdown>
                          </Form.Item>
                        </Col>
                      </Row>
                    ) : null}
                    <Form.Item
                      label={`${getSummaryLabel(index)}`}
                      className={"mb-0"}
                      name={[index, FormFields.SUMMARY_TRANSLATION]}
                      rules={[
                        {
                          required: true,
                          message: translate(
                            "editors.case_law_documents.required_messages",
                            {
                              field: label
                            }
                          )
                        }
                      ]}
                    >
                      <TextArea
                        onPaste={(event) => {
                          const formattedString =
                            event.clipboardData
                              .getData("text/plain")
                              .replace(/[\r\n\u0085\u2028\u2029]+/g, " ") || "";
                          event.clipboardData.setData(
                            "text/plain",
                            formattedString
                          );
                          event.preventDefault();
                          replaceSelectedText(
                            event.currentTarget,
                            formattedString
                          );
                          const obj = form.getFieldsValue();
                          const { summaryTranslations } = obj;
                          Object.assign(summaryTranslations[index], {
                            summaryTranslation: event.currentTarget.value
                          });
                          form.setFieldsValue({ summaryTranslations });
                        }}
                      />
                    </Form.Item>
                    {noteLabel && (
                      <Form.Item
                        label={`${getNoteLabel(index)}`}
                        className={"mb-0"}
                        name={[index, FormFields.NOTE_TRANSLATION]}
                        rules={[
                          {
                            required: true,
                            message: translate(
                              "editors.case_law_documents.required_messages",
                              {
                                field: noteLabel
                              }
                            )
                          }
                        ]}
                      >
                        <TextArea
                          onPaste={(event) => {
                            const formattedString =
                              event.clipboardData
                                .getData("text/plain")
                                .replace(/[\r\n\u0085\u2028\u2029]+/g, " ") ||
                              "";
                            event.clipboardData.setData(
                              "text/plain",
                              formattedString
                            );
                            event.preventDefault();
                            replaceSelectedText(
                              event.currentTarget,
                              formattedString
                            );
                            const obj = form.getFieldsValue();
                            const { summaryTranslations } = obj;
                            Object.assign(summaryTranslations[index], {
                              noteTranslation: event.currentTarget.value
                            });
                            form.setFieldsValue({ summaryTranslations });
                          }}
                        />
                      </Form.Item>
                    )}
                  </Col>

                  <Col style={{ display: "none" }}>
                    <Form.Item
                      className={"png-form-item-horizontal-checkbox "}
                      label={translate("editors.case_law_documents.valid")}
                      name={[index, FormFields.VALID]}
                      valuePropName={"checked"}
                      initialValue={true}
                    >
                      <Checkbox />
                    </Form.Item>
                  </Col>

                  <Col
                    lg={1}
                    md={1}
                    sm={4}
                    xs={4}
                    style={{
                      display: "none",
                      marginTop: 10,
                      alignItems: "center"
                    }}
                  >
                    <Button
                      danger
                      onClick={() => remove(field.name)}
                      size="small"
                      type={"link"}
                    >
                      <i
                        className={"fas fa-trash-alt"}
                        style={{ marginRight: 0 }}
                      ></i>
                    </Button>
                  </Col>
                </Row>
              ))}
              <Row className={"content-section-modal-borderless pb-0"}>
                <Col sm={24} xs={24} style={{ textAlign: "center" }}></Col>
              </Row>
            </>
          );
        }}
      </Form.List>
    );
  }
}
